import { smoothScroll } from '@shared/lib/helpers/smoothScroll'

export const scrollChat = (to: 'start' | 'end' | Element, duration = 300) => {
  const messagesList = document.querySelector('[data-name="gig-assist-messages"]')

  if (!messagesList) return

  const firstMessage = messagesList.firstElementChild
  const lastMessage = messagesList.lastElementChild

  const getElementToScroll = () => {
    if (to === 'start') return firstMessage
    else if (to === 'end') return lastMessage
    else if (typeof to === 'object') return to
  }

  const elementToScroll = getElementToScroll()
  if (!elementToScroll) return

  smoothScroll(elementToScroll as HTMLElement, duration)
}
